export abstract class ApiError extends Error {
  abstract code: number;
}
